import { render, staticRenderFns } from "./shopPay.vue?vue&type=template&id=97400e36&scoped=true"
import script from "./shopPay.vue?vue&type=script&lang=js"
export * from "./shopPay.vue?vue&type=script&lang=js"
import style0 from "./shopPay.vue?vue&type=style&index=0&id=97400e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97400e36",
  null
  
)

export default component.exports